<div class="ihost-input-spinner">
    <button class="btn-minus" (click)="prev()"><i class="icon-minus"></i></button>
    <input type="text" name="datePicker" [ngModel]="model" (change)="change($event)">
    <button class="btn-plus" (click)="next()"><i class="icon-plus"></i></button>
</div>